export { default } from './forte-bank';
